import { ComponentActivityDetailView } from '@/features/ComponentActivity/ComponentActivityDetailView/ComponentActivityDetailView';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const componentActivityDetailSearchSchema = z.object({
    aircraftId: z.coerce.number<number>().optional(),
    workOrderId: z.coerce.number<number>().optional(),
    filter: z.string().optional(),
    tab: z.enum(['line-items', 'removal-installation']).optional(),
});

export const Route = createFileRoute(
    '/removal_installation_list/$componentActivityId/',
)({
    component: ComponentActivityDetailView,
    validateSearch: componentActivityDetailSearchSchema,
});
